<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{$route.query.meetingId?'编辑':'创建'}}会议活动</span>
    </div>

    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item label="主题：" prop="topic" ref="topic">
        <el-input
          v-model="form.topic"
          style="width:350px;text-align:left"
          size="small"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-form-item label="类型：" :prop="form.type == 2?'project':null">
        <el-radio-group v-model="form.type">
          <el-radio label="1">售前会议</el-radio>
          <el-radio label="2">项目会议</el-radio>
        </el-radio-group>
        <select-tmpl
          v-if="form.type == 2"
          style="margin-left:10px"
          v-model="form.project"
          :dataOption="projectList"
          labels="name"
          values="id"
          placeholder="请选择项目"
          @select="selectProject"
          size="small"
        ></select-tmpl>

        <select-tmpl
          v-if="form.type == 2"
          style="margin-left:10px"
          v-model="form.projectVersion"
          :dataOption="versionList"
          :isMultiple="true"
          labels="version"
          values="id"
          placeholder="请选择版本"
          @select="selectVersion"
          size="small"
        ></select-tmpl>

        <!-- <el-cascader
        v-if="form.type == 2"
        ref="cascader"
        style="margin-left:10px"
        size="small"
        @change="cascaderChange"
        v-model="form.projectVersionIdList1"
        :props="cascaderProps"
        ></el-cascader>-->
      </el-form-item>
      <el-form-item label="时间：" prop="time">
        <!-- <el-date-picker
          v-model="form.time"
          range-separator="至"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
        />-->
        <el-date-picker
          v-model="form.day"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
        <el-time-picker
          is-range
          v-model="form.time"
          size="small"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="HH:mm:ss"
          placeholder="选择时间范围"
        ></el-time-picker>
      </el-form-item>
      <el-form-item label="地点：" prop="place" ref="place">
        <el-input
          v-model="form.place"
          style="width:300px;text-align:left"
          size="small"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="主持人：" required>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags1"
          closable
          effect="plain"
          :disable-transitions="false"
          @close="handleClose1(tag)"
        >{{tag}}</el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible1"
          v-model="inputValue1"
          ref="saveTagInput1"
          size="small"
          @keyup.enter.native="handleInputConfirm1"
          @blur="handleInputConfirm1"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput1">+ 请输入人员名单</el-button>
      </el-form-item>
      <el-form-item label="记录人：" prop="recordlabel">
        <el-select
          size="small"
          v-model="form.recordlabel"
          clearable
          @clear="clearRecordlabel"
          placeholder="请选择"
          style="width:300px"
        >
          <el-input
              size="mini"
              clearable
              v-if="treeData1.length != 0"
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              style="width: 300px;margin: 0 20px"
            >
          </el-input>
          <br>
          <!-- filterable
          ref="record"
          :filter-method="filterTree"-->
          <!-- :filter-node-method="filterNode" -->
          <el-option :label="form.recordlabel" :value="form.recordkey" class="optionTree">
            <el-tree
              :data="treeData1"
              :default-expanded-keys="treeExpandData"
              :default-checked-keys="form.recorderList"
              ref="recordlabel"
              node-key="key"
              show-checkbox
              @check="getChecked3"
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node1" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span v-if="data.mobile">({{data.jobName}})</span>
              </span>
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参与人员：" prop="joinlabel">
        <div>
          <span>内部人员：</span>
          <el-select
            size="small"
            v-model="form.joinlabel"
            clearable
            @clear="clearJoinlabel"
            placeholder="请选择"
            style="width:300px"
          >
            <el-input
              size="mini"
              clearable
              v-if="treeData1.length != 0"
              placeholder="输入关键字进行过滤"
              v-model="filterText2"
              style="width: 300px;margin: 0 20px"
            >
            </el-input>
            <br>
            <el-option :label="form.joinlabel" :value="form.joinkey" class="optionTree">
              <el-tree
                :data="treeData1"
                :default-expanded-keys="treeExpandData"
                :default-checked-keys="form.innerJoinerIdList"
                ref="joinlabel"
                node-key="key"
                show-checkbox
                @check="getChecked1"
                :filter-node-method="filterNode"
              >
                <span class="custom-tree-node1" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span v-if="data.mobile || data.jobName">({{data.jobName}})</span>
                </span>
              </el-tree>
            </el-option>
          </el-select>
          <el-popover placement="top" width="200" trigger="click" content="如果会议主持人为内部人员，请记得一并勾选。">
            <i
              slot="reference"
              class="el-icon-s-opportunity"
              style="margin-left:10px;cursor:pointer;outline: none;color:#bbb"
            ></i>
          </el-popover>
          <br />
          <div>
            <span>外部人员：</span>
            <!-- <el-input
              v-model="form.outerJoinerList"
              style="width:260px;text-align:left"
              size="small"
              placeholder="请输入人员名单，分号分隔"
            />-->
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              effect="plain"
              :disable-transitions="false"
              @close="handleClose(tag)"
            >{{tag}}</el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 请输入人员名单</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="邮件抄送人员：" prop="sendlabel">
        <el-select
          size="small"
          v-model="form.sendlabel"
          clearable
          @clear="clearSendlabel"
          placeholder="请选择"
          style="width:300px"
        >
          <el-input
            size="mini"
            clearable
            v-if="treeData1.length != 0"
            placeholder="输入关键字进行过滤"
            v-model="filterText3"
            style="width: 300px;margin: 0 20px"
          >
          </el-input>
          <br>

          <el-option :label="form.sendlabel" :value="form.sendkey" class="optionTree">
            <el-tree
              :data="treeData1"
              :default-expanded-keys="treeExpandData"
              :default-checked-keys="form.sendToIdList"
              ref="sendlabel"
              node-key="key"
              show-checkbox
              @check="getChecked2"
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node1" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span v-if="data.mobile">({{data.jobName}})</span>
              </span>
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容：" style="height:300px;" prop="content">
        <!-- <el-input
          ref="content"
          style="width:600px;text-align:left;margin-bottom: 25px;"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          placeholder="请输入内容"
          v-model="form.content"
        ></el-input> -->
        <quill-editor
          class="quill"
          ref="content"
          v-model="form.content"
          :options="editorOption"
          style="height:260px;"
        ></quill-editor>
      </el-form-item>
      <el-form-item label="会议附件：">
        <el-upload
          class="upload-demo"
          :action="UploadUrl + '/api/pc/file/upload'"
          :on-success="fileSuccess"
          :on-remove="fileRemove"
          :on-preview="filePreview"
          multiple
          :file-list="fileList"
          :headers="uploadHeaders"
        >
          <el-button size="small" type="primary">上传附件</el-button>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="onSubmit(form)" v-preventReClick>保存</el-button>
        <el-button size="small" @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import * as api from './api'
import * as comm from "utils/common";
import { addQuillTitle } from 'utils/quill-title.js'

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
  ['blockquote', 'code-block'], //引用、代码块儿
  [{ header: 1 }, { header: 2 }], //标题，键值对的形式；1、2表示字体大小
  [{ list: 'ordered' }, { list: 'bullet' }], //列表
  [{ script: 'sub' }, { script: 'super' }], //上下标
  [{ indent: '-1' }, { indent: '+1' }], //缩进
  [{ direction: 'rtl' }], //文本方向
  [{ size: ['small', false, 'large', 'huge'] }], //字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
  [{ color: [] }, { background: [] }], //字体颜色，字体背景颜色
  [{ font: [] }], //字体
  [{ align: [] }], //对齐方式
  ['clean'], //清除字体样式
  // ['image'], //上传图片
  // ['video'],//上传视频(video)
  // ['link'], // 超链接(link)
  //["sourceEditor"]
]

export default {
  data () {
    let that = this
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      editorOption: {
        modules: {
          // clipboard: {
          //   // 粘贴版，处理粘贴时候的自带样式
          //   matchers: [[Node.ELEMENT_NODE, this.HandleCustomMatcher]],
          // },
          toolbar: {
            container: toolbarOptions, // 工具栏
            // handlers: {
            //   image: function (value) {
            //     if (value) {
            //       // 获取隐藏的上传图片的class，不一定是.el-icon-plus。触发上传图片事件
            //       document.querySelector('.el-icon-plus').click()
            //     } else {
            //       this.quill.format('image', false)
            //     }
            //   },
            // },
          },
        },
        placeholder: '请输入内容',
      },
      //表单数据
      form: {
        //会议主题
        topic: "",
        //会议时间
        time: "",
        day: '',
        //会议地点
        place: "",
        //会议主持人
        hostList: [],
        dynamicTags1: [],
        //会议记录人
        recorderList: [],
        //内部人员
        innerJoinerIdList: [],
        //外部人员
        outerJoinerList: "",
        //抄送人员
        sendToIdList: [],
        projectVersionIdList: [],
        project: '',
        projectVersion: [],
        type: '2',
        content: "",
        fileKeyList: [],
        sendkey: '',
        sendlabel: '',
        joinkey: '',
        joinlabel: '',
        recordkey: '',
        recordlabel: ''
      },
      rules: {
        topic: [
          { required: true, message: '请输入会议主题', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        project: [
          { required: true, message: '请选择项目版本', trigger: 'change' }
        ],
        time: [
          { required: true, message: '请选择会议时间', trigger: 'change' }
        ],
        place: [
          { required: true, message: '请输入会议地点', trigger: 'blur' }
        ],
        // dynamicTags1: [
        //   {  required: true, message: '请输入会议主持人', trigger: 'blur' }
        // ],
        recordlabel: [
          { required: true, message: '请选择会议记录人', trigger: 'change' }
        ],
        joinlabel: [
          { required: true, message: '请选择会议参与者', trigger: 'change' }
        ],
        sendlabel: [
          { required: true, message: '请选择会议邮件抄送者', trigger: 'change' }
        ],
        joinlabel: [
          { required: true, message: '请选择会议参与者', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入会议内容', trigger: 'blur' }
        ]

      },
      fileList: [],
      //下拉框列表
      options: [{
        presonId: 1,
        value: '选项1',
        label: '张三'
      }, {
        presonId: 2,
        value: '选项2',
        label: '李四'
      }, {
        presonId: 3,
        value: '选项10',
        label: '周七'
      }],
      listProjects: [],
      currentIndex: -1,
      cascaderProps: {
        lazy: true,
        lazyLoad: that.myLoad,
        multiple: true,
        checkStrictly: false
      },
      treeData1: [],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      dynamicTags1: [],
      inputVisible1: false,
      inputValue1: '',
      uploadHeaders: {
        jwtToken: localStorage.getItem('jwtToken')
      },
      projectList: [],
      versionList: [],
      treeExpandData: [],
      filterText: '',
      filterText2: '',
      filterText3: ''
    }
  },
  // watch: {
  //   form(val) {
  //     console.log('val1',val);
  //       this.$refs.recordlabel.filter(val);

  //   }
  // },
  watch: {
    filterText(val) {
      this.$refs.recordlabel.filter(val);
    },
    filterText2(val) {
      this.$refs.joinlabel.filter(val);
    },
    filterText3(val) {
      this.$refs.sendlabel.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterTree (val) {
      console.log('val', val);
      // this.form.recordlabel = val
      this.$refs.recordlabel.filter(val);
    },
    onSubmit (form) {
      // if(!this.form.topic || !){
      //   this.$message.warning('请输入完整信息')
      //   return
      // }
      console.log('form', form);
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (!this.form.joinlabel) {
            this.form.innerJoinerIdList = []
          }
          if (!this.form.sendlabel) {
            this.form.sendToIdList = []
          }
          this.form.fileKeyList = this.fileList.map(item => item.fileKey)
          this.form.startTime = this.form.day + ' ' + this.form.time[0]
          this.form.endTime = this.form.day + ' ' + this.form.time[1]
          this.form.outerJoinerList = this.dynamicTags
          this.form.hostList = this.dynamicTags1
          if (this.form.type == 1) {
            this.form.project = ''
            this.form.projectVersion = []
          } else {
            if (!this.form.project) {
              this.$message.warning('项目名称不能为空')
              return
            }
            if (this.form.projectVersion.length === 0) {
              this.$message.warning('项目版本不能为空')
              return
            }
            this.form.projectVersionIdList = this.form.projectVersion
          }
          console.log(form)
          if (this.$route.query.meetingId) {
            api.meetingUpdate(this.form).then(res => {
              if (res.code === 1000) {
                this.$message.success(res.msg)
                this.$router.go(-1);
              }
            })
          } else {
            api.meetingadd(this.form).then(res => {
              if (res.code === 1000) {
                this.$message.success(res.msg)
                this.$router.go(-1);
              }
            })
          }
        } else {
          console.log('error submit!!');
          this.$message.warning('请填写完整信息');
          if (!this.form.topic) {
            this.$refs.topic.$el.querySelector('input').focus()
            return false
          }
          if (!this.form.place) {
            this.$refs.place.$el.querySelector('input').focus()
            return false
          }
          if (!this.form.content) {
            // console.log(this.$refs.content)
            this.$refs.content.$el.querySelector('textarea').focus()
            return false
          }
          return false;
        }
      });
    },
    clearRecordlabel () {
      this.form.recorderList = []
      this.form.recordkey = ''
      this.form.recordlabel = ''
      this.$refs.recordlabel.setCheckedKeys([])
      this.getSelectTree()
    },
    clearJoinlabel () {
      this.form.innerJoinerIdList = []
      this.form.joinkey = ''
      this.form.joinlabel = ''
      this.$refs.joinlabel.setCheckedKeys([])
      this.getSelectTree()
    },
    clearSendlabel () {
      this.form.sendkey = ''
      this.form.sendlabel = ''
      this.$refs.sendlabel.setCheckedKeys([])
      this.getSelectTree()
    },
    goBack () {
      this.$router.go(-1);
    },
    cascaderChange (e) {
      console.log(e, this.listProjects)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    fileSuccess (response, file, fileList) {
      console.log(response, file, fileList)
      if (response.code === 1000) {
        this.fileList.push({
          fileKey: response.data.key,
          name: file.name,
          path: response.data.path
        })
      } else {
        this.$message.error('上传失败' + response.msg)
      }
    },
    fileRemove (file, fileList) {
      // console.log(file, fileList, this.fileList)
      this.fileList = fileList
    },
    filePreview (e) {
      // window.open(e.path)
      comm.download(e.path, e.fileName)
    },
    getProjectList () {
      // api.listProject().then(res=>{
      //   this.projectList = res.data
      //   this.$route.query.meetingId && this.getDetail()
      // })

      api.getProject({ employeeId: this.currentUser.id }).then(res => {
        this.projectList = res.data.records
        this.$route.query.meetingId && this.getDetail()
      })
    },
    selectProject (e, fn) {
      console.log(e, fn)
      api.projectVersion({ projectId: e, size: -1 }).then(res => {
        this.versionList = res.data.records
        this.form.projectVersion = []
        if (fn) {
          fn()
        }
      })
    },
    selectVersion (e) {
      console.log(e)
    },
    getSelectTree () {
      api.getTreeAndPerson().then(res => {
        this.treeData1 = api.formatTreeAndPerson(res.data)
        console.log(this.treeData1,'this.treeData1')
        this.treeExpandData.push(this.treeData1[0].key)

      })
    },
    getChecked1 (checkedNodes, checkedKeys) {
      console.log(checkedKeys.checkedNodes)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile || (item.key && item.label)) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.form.innerJoinerIdList = keyList
      this.form.joinkey = keyList.join(';')
      this.form.joinlabel = labelList.join(';')

      console.log(this.form.innerJoinerIdList)
    },
    getChecked2 (checkedNodes, checkedKeys) {
      console.log(checkedKeys.checkedNodes)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.form.sendToIdList = keyList
      this.form.sendkey = keyList.join(';')
      this.form.sendlabel = labelList.join(';')

      console.log(this.form.sendToIdList)
    },
    getChecked3 (checkedNodes, checkedKeys) {
      // console.log(checkedNodes, checkedKeys)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
        if (item.mobile) {
          keyList.push(item.key)
          labelList.push(item.label)
        }
      })
      this.form.recorderList = keyList
      this.form.recordkey = keyList.join(';')
      this.form.recordlabel = labelList.join(';')

      console.log(this.form.recorderList)
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    handleClose1 (tag) {
      this.dynamicTags1.splice(this.dynamicTags1.indexOf(tag), 1);
    },

    showInput1 () {
      this.inputVisible1 = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput1.$refs.input.focus();
      });
    },

    handleInputConfirm1 () {
      let inputValue = this.inputValue1;
      if (inputValue) {
        this.dynamicTags1.push(inputValue);
      }
      this.inputVisible1 = false;
      this.inputValue1 = '';
    },
    getDetail () {
      // this.$route.query.meetingId
      api.meetingGetDetail(this.$route.query.meetingId).then(res => {
        this.form.id = res.data.id

        this.form.type = res.data.type + ''
        this.form.topic = res.data.topic
        this.form.place = res.data.place
        this.form.content = res.data.content
        let timelist = res.data.startTime.split(' ')
        this.form.day = timelist[0]
        this.form.time = []
        this.form.time.push(timelist[1])
        this.form.time.push(res.data.endTime.split(' ')[1])
        this.dynamicTags = res.data.outerJoinerList
        this.dynamicTags1 = res.data.hostList

        this.form.joinlabel = res.data.innerJoinEmployeeList.map(item => item.name).join(';')
        this.form.joinkey = res.data.innerJoinEmployeeList.map(item => item.id).join(';')
        this.form.innerJoinerIdList = res.data.innerJoinEmployeeList.map(item => item.id)

        this.form.sendkey = res.data.senderEmployeeList.map(item => item.id).join(';')
        this.form.sendlabel = res.data.senderEmployeeList.map(item => item.name).join(';')
        this.form.sendToIdList = res.data.senderEmployeeList.map(item => item.id)

        this.form.recordkey = res.data.recorderEmployeeList.map(item => item.id).join(';')
        this.form.recordlabel = res.data.recorderEmployeeList.map(item => item.name).join(';')
        this.form.recorderList = res.data.recorderEmployeeList.map(item => item.id)
        res.data.fileInfoVOList.forEach(item => {
          this.fileList.push({
            fileKey: item.key,
            name: item.fileName,
            path: item.path
          })
        })
        if (res.data.type == 2) {
          this.selectProject(res.data.projectVO.id, () => {
            this.form.projectVersion = res.data.projectVersionVOList.map(item => item.id)
          })
          this.form.project = res.data.projectVO.id
        }

      })
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  },
  created () {
    this.getProjectList()
    this.getSelectTree()
    // console.log(this.$route.query.meetingId)

  },
  mounted () {
    addQuillTitle();
    //   //中文输入发问题
    //   let self = this;
    //   var isInputZh = false;
    //   var typeEle = self.$refs.record.$el.children[0].children[0];

    //   typeEle.addEventListener('compositionstart', function (e) {
    //     isInputZh = true;
    //   }, false);

    //   typeEle.addEventListener('compositionend', function (e) {
    //     isInputZh = false;
    //     self.filterTree(typeEle.value);
    //   }, false);

    //   typeEle.addEventListener('input', function (e) {
    //     if (isInputZh) return;
    //     var value = this.value;
    //     self.filterTree(value);
    //   }, false);
  }
}
</script>

<style scoped>

.quill{
   line-height: normal;
}
.box-card {
  width: 85%;
  margin: 20px auto;
}
.header {
  height: 30px;
  background-color: #dcdee2;
  line-height: 30px;
  border: 0.5px solid #e8eaec;
  text-align: left;
  /* 缩进2个字节 */
  text-indent: 2em;
  margin-bottom: 20px;
}

.flotleft {
  float: left;
}

.outDiv {
  margin-left: 70px;
}

.divs {
  text-align: left;
  margin-left: 40px;
  margin-bottom: 15px;
}
.upload-demo {
  width: 300px;
}
.optionTree {
  width: 300px;
  height: auto;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/meeting-manage/CreatingMeeting.vue